import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { MessageService } from 'primeng/api';
import { eRoles } from '../../enums/enums';
import { Select } from '../../models/select';
import { DistributionCentersService } from '../../services/distribution-centers.service';
import { AppMainComponent } from '../main/app.main.component';
import { Account } from './models/account';

@Component({
	selector: 'app-topbar',
	templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit {
	activeProfileName: string;
	activeProfileRoles: string[];
	activeItem: number;
	distributionCenters: Select[];
	selectedDistributionCenter: any;
	administratorAccess = false;
	logisticsAccess = false;
	rolesEnum = eRoles;

	constructor(public app: AppMainComponent, private authService: MsalService, private messageService: MessageService,
		private distributionCenterService: DistributionCentersService) { }

	ngOnInit() {
		let account: Account = this.authService.instance.getAllAccounts()[0];
		this.administratorAccess = account.idTokenClaims['roles'].includes(this.rolesEnum.Admin);
		this.logisticsAccess = account.idTokenClaims['roles'].includes(this.rolesEnum.Logistics);
		if (account) {
			this.activeProfileName = account.name;

			if (account.idTokenClaims?.roles) {
				this.activeProfileRoles = account.idTokenClaims.roles;
			}
			if (this.administratorAccess || this.logisticsAccess) {
				this.distributionCenterService.getComboExtended().subscribe((data) => {
					this.distributionCenters = data;
					this.selectedDistributionCenter = data[0];
				});
			}
		}
	}

	mobileMegaMenuItemClick(index) {
		this.app.megaMenuMobileClick = true;
		this.activeItem = this.activeItem === index ? null : index;
	}

	logout() {
		this.authService.logoutRedirect();
	}

	setDeliveryLimit(val) {
		if (val == null || val == undefined) {
			this.messageService.add({ severity: "warn", summary: "Advertencia", detail: "Debe ingresar un valor." });
		} else {
			if (this.selectedDistributionCenter.deliveryLimitedTo != val) {
				this.distributionCenterService.setDeliveryLimit(this.selectedDistributionCenter.id, val).subscribe((result) => {
					this.messageService.add({ severity: "success", summary: "Grabación exitosa", detail: "Cantidad modificada." });
				});
			}
		}
	}
}
